/**
 * Role Constants
 * 
 * Single source of truth for all role identifiers.
 * Use these constants instead of hardcoded strings.
 * 
 * @module roleConstants
 */

export const ROLES = {
  BASIC: 'basic',
  PREMIUM: 'premium',
  PRO1: 'pro1',
  PRO2: 'pro2',
  ADMIN: 'admin'
};

/**
 * Tier Constants
 * 
 * Single source of truth for all tier identifiers.
 * Use these constants instead of hardcoded strings.
 * 
 * @module roleConstants
 */
export const TIERS = {
  FREE: 'free',
  PREMIUM: 'premium',
  ELITE: 'elite'
};

